import { render, staticRenderFns } from "./orders_analysis.vue?vue&type=template&id=59db0948&scoped=true"
import script from "./orders_analysis.vue?vue&type=script&lang=js"
export * from "./orders_analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db0948",
  null
  
)

export default component.exports